<template>
  <div
    v-if="isVisible"
    :class="[
      'absolute right-0 shadow-lg rounded-sm border bg-EXPONDO-secondary text-EXPONDO-white',
      position === 'bottom' ? 'top-full mt-1' : '-top-6',
    ]"
  >
    <span class="text-sm whitespace-nowrap p-2">{{ message }}</span>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ActionPopup',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'top',
      validator: (value: string) => ['top', 'bottom'].includes(value),
    },
  },
});

</script>
